export class CustomError extends Error {
  public code: string

  constructor(code: string, message?: string) {
    super(code)
    this.code = code
    this.message = message || code
  }
}
